<!-- addAttractionFromImage.vue -->
<template>
  <BaseFromImage 
    dateTitle="this is the date to add the attraction"
    :addToRide="addToRide"
  />
</template>

<script>
import BaseFromImage from '@/components/BaseFromImage.vue';
import { mapActions } from 'vuex';
import { UPLOAD_RIDE_STATES } from '@/constants/uploadRideStates.js';

export default {
  components: {
    BaseFromImage, // Register the component here
  },
  methods: {
    ...mapActions([ 'addAttractionToRideFromImage',
    ]),
    async addToRide(place) {
      await this.addAttractionToRideFromImage(place);
    },
  },
  mounted() {
    this.$store.commit('setUploadRideState', UPLOAD_RIDE_STATES.ADDING_ATRACTIONS_FROM_IMAGES);
  },
};
</script>